import React from 'react';
import { motion } from 'framer-motion';
export function FounderProfile() {
  return <section id="profile" className="pt-10 relative" data-id="element-57">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} data-id="element-58">
        {/* Hero Section with Headshot */}
        <div className="mb-16 grid md:grid-cols-2 gap-8 items-center relative" data-id="element-59">
          <div data-id="element-60">
            <h1 className="text-4xl md:text-6xl font-bold mb-6 tracking-tight leading-tight" data-id="element-61">
              BUILDING THE INTERNET YOU WISH YOU HAD.
            </h1>
            <h2 className="text-xl md:text-2xl mb-8 leading-relaxed font-normal" data-id="element-62">
              I want to create the tech that reminds you that you're not broken
              — the world is.
            </h2>
            <h2 className="text-xl md:text-2xl mb-8 leading-relaxed font-normal" data-id="element-63">
              In 10 years, I want thousands of people to have basic income
              because of the art and community they created.
            </h2>
            <div className="flex gap-2 mb-6" data-id="element-64">
              {['#FF0000', '#FF8800', '#FFDD00', '#00DD00', '#0088FF', '#8800FF'].map((color, i) => <div key={i} className="h-2 flex-1" style={{
              backgroundColor: color
            }} data-id="element-65" />)}
            </div>

            {/* CTA Button in Hero */}
            <motion.a href="https://dunjaparty.substack.com/" target="_blank" rel="noopener noreferrer" className="block w-full py-4 text-black font-bold text-lg border-4 border-black relative overflow-hidden text-center no-underline" style={{
            backgroundColor: '#00DD00'
          }} whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} data-id="element-66">
              SUPPORT ME
            </motion.a>
          </div>

          {/* Headshot with decorative frame */}
          <motion.div className="relative" initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.2
        }} data-id="element-67">
            <div className="aspect-square overflow-hidden border-8 border-black relative" style={{
            borderRadius: '60% 40% 30% 70% / 60% 30% 70% 40%'
          }} data-id="element-68">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6dGwRtaBmWA7zBaRmUQdZN/headshot.jpg" alt="Founder" className="w-full h-full object-cover" data-id="element-69" />
            </div>
          </motion.div>
        </div>

        {/* What I'm Building - 2 columns, 1 row */}
        <div className="mb-16 grid md:grid-cols-2 gap-8 items-center" data-id="element-70">
          <div className="space-y-4 text-lg leading-relaxed" data-id="element-71">
            <h3 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-72">
              WHAT I'M BUILDING
            </h3>
            <p data-id="element-73">
              A media publishing house run like a profitable tech company —
              where creators learn, teach, and earn without selling out.
            </p>
            <p className="font-bold" data-id="element-74">
              Every creator I help becomes a mentor for the next — this is how
              we scale impact, not burnout.
            </p>
            <p className="font-bold text-xl" style={{
            color: '#8800FF'
          }} data-id="element-75">
              I'm building a life I want to be in, not escape from.
            </p>
          </div>

          {/* Illustration - no frame */}
          <motion.div className="relative" initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} data-id="element-76">
            <img src="https://cdn.magicpatterns.com/uploads/tsWDsuHm1Bcb1VizE52Xa3/trendy-abstract-illustration-circus-clown.png" alt="Community illustration" className="w-full h-auto" data-id="element-77" />
          </motion.div>
        </div>
      </motion.div>
    </section>;
}